import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import PageLoading from "components/PageLoading";
import { useAuth } from "../../context/AuthContext";
import { clearAuthSession, getStoredToken } from "../../services/authSession";
import { PATHS } from "../../routes/paths";

const UserRoles: Record<number, string> = {
  1: "Administrador TI",
  2: "Administrador",
  3: "Analista",
  4: "Sindicato",
};

interface PrivateRouteProps {
  children?: React.ReactNode;
  requiredpermission?: string[];
}

const PrivateRoute = ({
  children,
  requiredpermission,
}: PrivateRouteProps): React.ReactElement => {
  const { perfil, loading, perfilStatus } = useAuth();
  const [isAuth, setIsAuth] = useState<boolean | null>(null);

  useEffect(() => {
    const decidirAuth = () => {
      const token = getStoredToken();

      if (!token) {
        setIsAuth(false);
        return;
      }

      if (loading) return;

      if (perfil) {
        const roleKey = Number(
          (perfil as any).idPerfil !== undefined
            ? (perfil as any).idPerfil
            : (perfil as any).id,
        );

        const role = UserRoles[roleKey];
        const allowed =
          !requiredpermission || requiredpermission.includes(role);

        setIsAuth(Boolean(allowed));
        return;
      }

      console.warn(
        "[PrivateRoute] Token existe, mas perfil não está disponível (perfilStatus:",
        perfilStatus,
        "). Bloqueando e limpando sessão.",
      );
      clearAuthSession();
      setIsAuth(false);
    };

    decidirAuth();
  }, [perfil, loading, perfilStatus, requiredpermission]);

  if (isAuth === null || loading) {
    return <PageLoading minHeight="100vh" />;
  }

  if (!isAuth) {
    return <Navigate to={PATHS.LOGIN} replace />;
  }

  return (children ? <>{children}</> : <Outlet />) as React.ReactElement;
};

export default PrivateRoute;